import { getEnvsVariable } from "./getEnvsVariable";

// Loads gtag.js only when VITE_GOOGLE_ANALYTICS_ID is present (set exclusively
// in the production deployment overlay), so no other environment loads it.
export const initGoogleAnalytics = () => {
  const { VITE_GOOGLE_ANALYTICS_ID } = getEnvsVariable();

  if (!VITE_GOOGLE_ANALYTICS_ID || window.dataLayer) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${VITE_GOOGLE_ANALYTICS_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", VITE_GOOGLE_ANALYTICS_ID);
};
